import httpClient from "./httpClient";

const patchApiData = async (url, body) => {
  try {
    const response = await httpClient.patch(url, body);
    return response;
  } catch (error) {
    console.error("Error:", error);
  }
};

export default patchApiData;
